module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEmSURBVHgBjZKxTsNADIbtS1DFloFIjJmQUjEkT1B4gzBEYmv7JuUJwiOEDcjQ8gTQJ2iQEJWYwkoYwkhDztiRgk5VRGsp8Z3v89m/dQB7mhu/BOLxP+j4cu1pDRNEGBOBR9SE9jbkRCtnMDgcA1DEcMBgzmGPv6LMTnN7G2Ig0KRT9jME+wuxmXMjOe9TYW3pDdF61HwdAUQ/9fdztQgrN34LBCayLsTXNTz8aTiKX0eocIIEZ5z1BEh8iInAltU4WlPycT8MhVXy+8yGy/LOn24UnFMbwTkXnJbZSa6JBQNedxqVKbi69QtJ5OVMKRi1QYKo3sCyY+y+cXKlm4OGVm68fpcpVQu/6K1gVpLJ8PUJq0zNs96EthOCK0R0zHZ2WvccTPsFRoSA8ir/R8EAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m4.png
// module id = loym
// module chunks = 1